var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartureIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1184_4955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#DEA829"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1184_4955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7191 5.24944C16.4876 5.24944 14.6562 5.2363 13.4247 5.25765C12.9118 5.26668 12.6127 5.62948 12.5975 6.16794C12.5895 6.44127 12.6063 6.71543 12.5903 6.98794C12.5584 7.52558 12.2107 7.87279 11.7289 7.8695C11.2639 7.86622 10.8914 7.52722 10.8906 7.01421C10.889 6.45851 10.8866 5.88147 11.0214 5.3504C11.2974 4.25706 12.2912 3.50847 13.3888 3.50519C16.4979 3.49698 19.6079 3.49862 22.7171 3.5093C23.8003 3.5134 24.4974 4.25706 24.4982 5.37995C24.5006 10.5487 24.4998 15.7182 24.4982 20.8869C24.4982 21.8112 24.0802 22.4186 23.2379 22.7091C21.6156 23.2698 19.9924 23.8287 18.3668 24.3787C17.0682 24.8187 15.9994 24.0233 15.9827 22.6164C15.9803 22.3874 15.9827 22.1584 15.9827 21.8883C15.1755 21.8883 14.4081 21.8883 13.6408 21.8883C11.9466 21.8867 10.8826 20.7901 10.8778 19.0442C10.877 18.5656 10.8706 18.0871 10.8802 17.6086C10.8922 17.0176 11.2384 16.6334 11.7401 16.6359C12.2402 16.6383 12.5824 17.0233 12.5927 17.6168C12.6023 18.1634 12.5863 18.7109 12.5999 19.2576C12.6119 19.7517 12.9062 20.1088 13.3808 20.126C14.2271 20.1564 15.0758 20.1342 15.9827 20.1342V19.6294C15.9827 15.5409 15.9914 11.4516 15.9763 7.36306C15.9731 6.4265 18.9339 6.00375 19.3726 5.24944H17.7191Z",
    fill: "url(#paint0_linear_1184_4955)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62136 11.3811C8.62136 10.5373 8.61578 9.75836 8.62375 8.98022C8.62854 8.5222 8.52086 8.13067 8.07099 7.94517C7.63708 7.76623 7.31005 7.97307 7.00855 8.28663C5.9804 9.35452 4.94348 10.4134 3.91214 11.4772C3.36815 12.0386 3.36416 12.472 3.89858 13.0236C4.93949 14.0972 5.98518 15.1659 7.0229 16.2429C7.326 16.5572 7.65303 16.7501 8.08774 16.5613C8.51926 16.3734 8.62455 15.9974 8.62216 15.5566C8.61737 14.7662 8.62056 13.9749 8.62056 13.1278C8.84948 13.1278 9.0449 13.1278 9.23952 13.1278C10.1424 13.1278 11.0454 13.1336 11.9483 13.1246C12.4987 13.1196 12.8632 12.7683 12.8672 12.2652C12.8711 11.7505 12.4899 11.3861 11.9252 11.3828C10.9688 11.3778 10.0132 11.3811 9.05687 11.3811C8.92685 11.3811 8.79764 11.3811 8.62136 11.3811Z",
    fill: "url(#paint1_linear_1184_4955)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1184_4955",
    x1: 17.6874,
    y1: 3.5,
    x2: 17.6874,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1184_4955",
    x1: 8.18406,
    y1: 7.87891,
    x2: 8.18406,
    y2: 16.6359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartureIcon);
export default __webpack_public_path__ + "static/media/departure_icon.243503da5cc4de09dbe58f1e33e8710f.svg";
export { ForwardRef as ReactComponent };